import * as React from 'react';
import { FirstViewForNewKeyVisual } from '../../components/organisms/trial/first_view/FirstViewForNewKeyVisual';
import { FirstViewForDocumentLp } from '../../components/organisms/trial_document01/FirstViewForDocument';
import { FirstView } from '../../components/organisms/trial/first_view/FirstView';
import {observer} from "mobx-react";

type Props = {
    isOptimizeTestUrl: boolean;
    isDocumentLp: boolean;
};

export const TrialLessonPageFirstView = observer(({ isOptimizeTestUrl, isDocumentLp }: Props) => {
    if (isOptimizeTestUrl) {
        return <FirstViewForNewKeyVisual />;
    }
    if (isDocumentLp) {
        return <FirstViewForDocumentLp />;
    }
    return <FirstView />;
});
